<template>
    <div>
        <div>
            <div class="form-group">
                <label for="setting-company-cd">企業コード</label>
                <input id="setting-company-cd" type="text" class="form-control" v-model="settingCompanyCd">
            </div>
            <div class="form-group">
                <label for="setting-store-cd">店舗コード</label>
                <input id="setting-store-cd" type="text" class="form-control" v-model="storeCd">
            </div>
            <div class="form-group">
                <label for="setting-user-id">ユーザー名</label>
                <input id="setting-user-id" type="text" class="form-control" v-model="userName">
            </div>
            <div class="form-group">
                <label for="setting-password">パスワード</label>
                <input id="setting-password" type="password" class="form-control" v-model="password">
            </div>
            <div class="form-group">
                <label for="setting-format-id">レイアウトNo</label>
                <input id="setting-format-id" type="text" class="form-control" v-model="formatId">
            </div>
            <div class="form-group">
                <label for="setting-half-price-format-id">半額用レイアウトNo</label>
                <input id="setting-half-price-format-id" type="text" class="form-control" v-model="halfPriceFormatId">
            </div>

            <button class="btn btn-primary" @click="saveSetting()">保存</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Setting',
    components: {
    },
    data() {
        const setting = this.$store.state.setting
        return {
            name: "setting",
            settingCompanyCd: setting.companyCd,
            storeCd: setting.storeCd,
            userName: setting.userName,
            password: setting.password,
            formatId: setting.formatId,
            halfPriceFormatId: setting.halfPriceFormatId,
            printerURL: setting.printerURL,
        }
    },
    methods: {
        saveSetting() {
            console.log("save setting")
            this.$store.commit('setting/saveSetting', {
                companyCd: this.settingCompanyCd,
                storeCd: this.storeCd,
                userName: this.userName,
                password: this.password,
                formatId: this.formatId,
                halfPriceFormatId: this.halfPriceFormatId,
                printerURL: this.printerURL,
            })
        },
    },
}
</script>
